import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import type { Requisition } from '@recruitee/requisitions-types';

import {
  RequisitionsAbilities,
  RequisitionsDataProviderService,
} from '../../data/single-requisition/requisitions-data-provider.service';

@Injectable()
export class TeamMembersFacade {
  private requisition: Requisition;
  private abilities: RequisitionsAbilities;
  private isRequisitionReadOnly: boolean;
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    protected store: Store,
    protected requisitionsData: RequisitionsDataProviderService,
  ) {
    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ requisition, abilities, isRequisitionReadOnly }) => {
        this.requisition = requisition;
        this.abilities = abilities;
        this.isRequisitionReadOnly = isRequisitionReadOnly;
      });
  }

  public get canEditTeamMembers(): boolean {
    return this.abilities.manageRequisitions && !this.isRequisitionReadOnly;
  }

  // TODO - move logic from requisitions-team-members.service here

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
